/* =====================================================================
   Buscador de Carreras PAES 2026 — EurekaPAES
   Módulo: Mis Carreras Favoritas + Simulador Global (v6)
   Cambios v6 (jul 2026, por petición del usuario):
     - Eliminada la vista "Prioridades" (kanban): quedan tarjetas / tabla
     - Eliminados radar "Mi perfil PAES", "Distribución por estado",
       "Mi plan de ataque PAES" y "¿Qué prueba te conviene reforzar?"
   Cambios v5:
     - Persistencia de vista activa en localStorage
     - Fix bug Limpiar favoritos: actualiza estrellas en DOM + modal
     - Eliminado bloque "prueba clave más repetida"
     - Grid de puntajes globales reorganizado (4+3 desktop)
   localStorage:
     - ep_paes_favs_v1       (Array<string>)
     - ep_paes_puntajes_v1   (Object)
     - ep_paes_vista_v1      ("tarjetas"|"tabla")
   ===================================================================== */
(function () {
  'use strict';

  var LS_FAV    = 'ep_paes_favs_v1';
  var LS_PUNTAJ = 'ep_paes_puntajes_v1';
  var LS_VISTA  = 'ep_paes_vista_v1';

  var PRUEBAS = [
    { key: 'nem',                 label: 'NEM',                     corto: 'NEM',     icon: '📝' },
    { key: 'ranking',             label: 'Ranking',                 corto: 'Ranking', icon: '📈' },
    { key: 'competencia_lectora', label: 'Competencia Lectora',     corto: 'CLEC',    icon: '📖' },
    { key: 'matematica_m1',       label: 'Matemática M1',           corto: 'M1',      icon: '➕' },
    { key: 'matematica_m2',       label: 'Matemática M2',           corto: 'M2',      icon: '∫' },
    { key: 'ciencias',            label: 'Ciencias',                corto: 'Ciencias',icon: '🔬' },
    { key: 'historia',            label: 'Historia y CC. Sociales', corto: 'Historia',icon: '📜' }
  ];

  var VISTAS = [
    { id: 'tarjetas',    label: 'Tarjetas',    icon: '🃏' },
    { id: 'tabla',       label: 'Tabla',       icon: '📋' }
  ];

  /* ============ localStorage helpers (con sanitización SEC) ============
     Cualquier dato leído desde localStorage se valida estrictamente:
       - Favoritos: array de strings con formato código DEMRE (5 dígitos),
         deduplicados y limitados a MAX_FAVS.
       - Puntajes:  objeto con SOLO claves whitelistadas, números finitos
         clampeados a 0-1000.
       - Vista:     whitelist tarjetas|tabla.
     Si el valor está corrupto, se devuelve fallback seguro y, si se detecta
     que está sucio, se reescribe la versión limpia para auto-curarse.
  ================================================================= */
  var SEC = {
    DEMRE_RE: /^\d{5}$/,
    PUNT_KEYS: ['nem','ranking','competencia_lectora','matematica_m1','matematica_m2','ciencias','historia'],
    VISTAS:   ['tarjetas','tabla'],
    MAX_FAVS: 100
  };

  /* FIX CRÍTICO (jul 2026): state debe inicializarse DESPUÉS de definir SEC.
     Antes, loadFavs()/loadPuntajes() corrían con SEC aún undefined → TypeError
     → el catch borraba ep_paes_favs_v1 y ep_paes_puntajes_v1 EN CADA CARGA.
     Este era el bug de "F5 borra mis datos". */
  var state = {
    favs:     loadFavs(),
    puntajes: loadPuntajes(),
    vista:    loadVista(),
    expanded: true
  };
  function isValidDemreCode(s) {
    return typeof s === 'string' && SEC.DEMRE_RE.test(s);
  }
  function sanitizeFavsArray(arr) {
    if (!Array.isArray(arr)) return [];
    var seen = {}, out = [];
    for (var i = 0; i < arr.length && out.length < SEC.MAX_FAVS; i++) {
      var c = arr[i];
      if (!isValidDemreCode(c)) continue;          /* descarta strings raros, HTML, números, objetos */
      if (seen[c]) continue;                       /* dedupe */
      seen[c] = 1; out.push(c);
    }
    return out;
  }
  function sanitizePuntajesObj(obj) {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return {};
    var clean = {};
    for (var i = 0; i < SEC.PUNT_KEYS.length; i++) {
      var k = SEC.PUNT_KEYS[i];
      if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
      var v = obj[k];
      if (v == null) continue;
      if (typeof v !== 'number' && typeof v !== 'string') continue; /* descarta arrays/objetos */
      var n = typeof v === 'number' ? v : parseFloat(v);
      if (!isFinite(n)) continue;                  /* descarta NaN, Infinity, strings raros */
      if (n < 0) n = 0;
      if (n > 1000) n = 1000;
      clean[k] = n;
    }
    return clean;
  }
  function sanitizeVista(v) {
    return SEC.VISTAS.indexOf(v) >= 0 ? v : 'tarjetas';
  }
  /* Detecta si localStorage es funcional (incógnito/permisos bloqueados lo deshabilitan) */
  function storageAvailable() {
    try {
      var k = '__ep_paes_probe__';
      localStorage.setItem(k, '1');
      localStorage.removeItem(k);
      return true;
    } catch (e) { return false; }
  }

  function loadFavs() {
    try {
      var raw = localStorage.getItem(LS_FAV);
      var arr = raw ? JSON.parse(raw) : [];
      var clean = sanitizeFavsArray(arr);
      /* Auto-curado: si el array original difiere del limpio, reescribir. */
      if (raw && JSON.stringify(clean) !== JSON.stringify(arr)) {
        try { localStorage.setItem(LS_FAV, JSON.stringify(clean)); } catch (e) {}
      }
      return new Set(clean);
    } catch (e) {
      /* JSON corrupto → limpiamos por completo */
      try { localStorage.removeItem(LS_FAV); } catch (e2) {}
      return new Set();
    }
  }
  function saveFavs() {
    try {
      var clean = sanitizeFavsArray(Array.from(state.favs));
      localStorage.setItem(LS_FAV, JSON.stringify(clean));
    } catch (e) {}
  }
  function loadPuntajes() {
    try {
      var raw = localStorage.getItem(LS_PUNTAJ);
      var obj = raw ? JSON.parse(raw) : {};
      var clean = sanitizePuntajesObj(obj);
      if (raw && JSON.stringify(clean) !== JSON.stringify(obj)) {
        try { localStorage.setItem(LS_PUNTAJ, JSON.stringify(clean)); } catch (e) {}
      }
      return clean;
    } catch (e) {
      try { localStorage.removeItem(LS_PUNTAJ); } catch (e2) {}
      return {};
    }
  }
  function savePuntajes() {
    try {
      var clean = sanitizePuntajesObj(state.puntajes);
      state.puntajes = clean;
      localStorage.setItem(LS_PUNTAJ, JSON.stringify(clean));
    } catch (e) {}
  }
  function loadVista() {
    try {
      var v = localStorage.getItem(LS_VISTA);
      return sanitizeVista(v);
    } catch (e) { return 'tarjetas'; }
  }
  function saveVista() {
    try { localStorage.setItem(LS_VISTA, sanitizeVista(state.vista)); } catch (e) {}
  }

  /* Expongo helpers de sanitización para que otros módulos los reutilicen */
  if (typeof window !== 'undefined') {
    window.EpSec = window.EpSec || {};
    window.EpSec.isValidDemreCode = isValidDemreCode;
    window.EpSec.sanitizeFavsArray = sanitizeFavsArray;
    window.EpSec.sanitizePuntajesObj = sanitizePuntajesObj;
    window.EpSec.sanitizeVista = sanitizeVista;
    window.EpSec.storageAvailable  = storageAvailable;

    /* ============ window.EpDebugStorage() — diagnóstico de persistencia
       Ejecutar en la consola del navegador para ver el estado completo
       de los datos guardados. Útil cuando se sospecha que F5 borra datos. */
    window.EpDebugStorage = function () {
      var rep = {};
      rep.protocolo = location.protocol;
      rep.url = location.href;
      rep.storageAvailable = storageAvailable();
      rep.timestamp = new Date().toISOString();

      function safeRead(key) {
        try {
          var raw = localStorage.getItem(key);
          return { raw: raw, parsed: raw ? JSON.parse(raw) : null };
        } catch (e) { return { raw: '(error)', parsed: null, error: e.message }; }
      }

      rep.ep_paes_favs_v1      = safeRead(LS_FAV);
      rep.ep_paes_puntajes_v1  = safeRead(LS_PUNTAJ);
      rep.ep_paes_vista_v1     = safeRead(LS_VISTA);
      rep.ep_paes_recientes_v1 = safeRead('ep_paes_recientes_v1');
      rep.ep_paes_onboard_v1   = safeRead('ep_paes_onboard_v1');
      rep.ep_paes_alcanzo_v1   = safeRead('ep_paes_alcanzo_v1');

      rep.estado_memoria = {
        favs_count: state.favs ? state.favs.size : 0,
        puntajes_count: state.puntajes ? Object.keys(state.puntajes).length : 0,
        vista_activa: state.vista,
        favs_set: state.favs ? Array.from(state.favs) : [],
        puntajes_obj: state.puntajes || {}
      };

      /* Test de escritura/lectura en vivo */
      var probeKey = '__ep_paes_debug_probe__';
      var probeVal = 'probe-' + Date.now();
      try {
        localStorage.setItem(probeKey, probeVal);
        var readBack = localStorage.getItem(probeKey);
        localStorage.removeItem(probeKey);
        rep.test_escribir_leer = readBack === probeVal ? 'OK ✅' : 'FALLO ❌ (escribió pero no leyó lo mismo)';
      } catch (e) {
        rep.test_escribir_leer = 'BLOQUEADO ❌ ' + e.message;
      }

      console.group('%c💾 EpDebugStorage', 'background:#6F1E97;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold;');
      console.table({
        'Protocolo':            rep.protocolo,
        'storageAvailable()':   rep.storageAvailable,
        'Test escribir/leer':   rep.test_escribir_leer,
        'favs en memoria':      rep.estado_memoria.favs_count,
        'puntajes en memoria':  rep.estado_memoria.puntajes_count,
        'vista activa':         rep.estado_memoria.vista_activa
      });
      console.log('Estado completo:', rep);
      if (rep.protocolo === 'file:') {
        console.warn('⚠️ Estás en file://. Chrome/Edge pueden no persistir localStorage de forma confiable entre F5. Para probar persistencia, abre con http://localhost (ver README → Persistencia local).');
      }
      console.groupEnd();
      return rep;
    };

    /* Log de diagnóstico al cargar — visible en consola pero no en UI */
    try {
      console.log('%c[EurekaPAES] Persistencia inicializada', 'color:#6F1E97;font-weight:bold;', {
        protocolo: location.protocol,
        storageAvailable: storageAvailable(),
        favs_cargados: state.favs.size,
        puntajes_cargados: Object.keys(state.puntajes).length,
        vista: state.vista,
        tip: 'Ejecuta window.EpDebugStorage() para diagnóstico completo'
      });
    } catch (e) {}
  }

  /* ============ Util ============ */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
        var v = attrs[k];
        if (v == null || v === false) continue;
        if (k === 'class') n.className = v;
        else if (k === 'text') n.textContent = v;
        else if (k === 'html') n.innerHTML = v;
        else if (k.indexOf('on') === 0 && typeof v === 'function') n.addEventListener(k.substring(2), v);
        else n.setAttribute(k, v);
      }
    }
    if (children) {
      if (!Array.isArray(children)) children = [children];
      for (var i = 0; i < children.length; i++) {
        var c = children[i];
        if (c == null || c === false) continue;
        if (typeof c === 'string') n.appendChild(document.createTextNode(c));
        else n.appendChild(c);
      }
    }
    return n;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/`/g, '&#96;');
  }
  function clamp(v, mn, mx) {
    if (isNaN(v)) return NaN;
    if (v < mn) return mn;
    if (v > mx) return mx;
    return v;
  }
  function fmt(p) {
    if (p == null) return '—';
    return (typeof p === 'number' && p % 1 !== 0) ? p.toFixed(1) : String(p);
  }
  function getDataArr() {
    return (window.EP_PAES_DATA && Array.isArray(window.EP_PAES_DATA)) ? window.EP_PAES_DATA : [];
  }
  function findByCode(cod) {
    var arr = getDataArr();
    for (var i = 0; i < arr.length; i++) if (arr[i].codigo_demre === cod) return arr[i];
    return null;
  }
  function lblPrueba(key) {
    for (var i = 0; i < PRUEBAS.length; i++) if (PRUEBAS[i].key === key) return PRUEBAS[i].label;
    return key;
  }
  function cortoPrueba(key) {
    for (var i = 0; i < PRUEBAS.length; i++) if (PRUEBAS[i].key === key) return PRUEBAS[i].corto;
    return key;
  }

  /* ============ Cálculo ponderado (respeta electiva) ============ */
  function computar(carrera, puntajes) {
    var p = carrera.ponderaciones || {};
    var keys = Object.keys(p).filter(function (k) { return p[k] > 0; });
    if (keys.length === 0) {
      return { pond: null, faltan: [], electivaUsada: null, electivaDescartada: null, completo: false };
    }
    var electiva = !!carrera.electiva_ciencias_historia;
    var ingresados = {};
    var faltan = [];
    keys.forEach(function (k) {
      var v = puntajes[k];
      if (v == null || isNaN(v)) faltan.push(k);
      else ingresados[k] = v;
    });
    var faltElectiva = false;
    if (electiva) {
      var hasC = (ingresados.ciencias != null);
      var hasH = (ingresados.historia != null);
      faltan = faltan.filter(function (k) { return k !== 'ciencias' && k !== 'historia'; });
      if (!hasC && !hasH) { faltElectiva = true; faltan.push('electiva_ciencias_historia'); }
    }
    if (faltan.length > 0) {
      return { pond: null, faltan: faltan, electivaUsada: null, electivaDescartada: null, completo: false, faltElectiva: faltElectiva };
    }
    var total = 0;
    var electivaUsada = null, electivaDescartada = null;
    if (electiva) {
      var pct = p.ciencias;
      var aC = (ingresados.ciencias != null) ? ingresados.ciencias * (pct / 100) : -Infinity;
      var aH = (ingresados.historia != null) ? ingresados.historia * (pct / 100) : -Infinity;
      if (aC >= aH) {
        electivaUsada = 'ciencias';
        electivaDescartada = (ingresados.historia != null) ? 'historia' : null;
        total += aC === -Infinity ? 0 : aC;
      } else {
        electivaUsada = 'historia';
        electivaDescartada = (ingresados.ciencias != null) ? 'ciencias' : null;
        total += aH === -Infinity ? 0 : aH;
      }
    }
    keys.forEach(function (k) {
      if (electiva && (k === 'ciencias' || k === 'historia')) return;
      total += ingresados[k] * (p[k] / 100);
    });
    return {
      pond: Math.round(total * 10) / 10,
      faltan: [], electivaUsada: electivaUsada, electivaDescartada: electivaDescartada, completo: true
    };
  }

  function clasificar(diff) {
    if (diff == null) return { id: 'sin', label: 'Sin meta', msg: 'No hay puntaje de referencia para comparar.' };
    if (diff <= 0)    return { id: 'sobre', label: 'Sobre la meta', msg: 'Vas muy bien para esta carrera.' };
    if (diff <= 30)   return { id: 'cerca', label: 'Muy cerca',     msg: 'Estás a pocos puntos. Enfócate en tu prueba clave.' };
    if (diff <= 80)   return { id: 'camino',label: 'En camino',     msg: 'Todavía puedes acercarte con una estrategia clara.' };
    return                  { id: 'reforz',label: 'Falta reforzar',msg: 'Conviene priorizar las pruebas que más ponderan.' };
  }

  function getMeta(carrera) {
    if (carrera.ponderado_ultimo_matriculado != null) return carrera.ponderado_ultimo_matriculado;
    return null;
  }
  function pruebaTop(pond) {
    var max = -1, key = null;
    for (var k in pond) {
      if (Object.prototype.hasOwnProperty.call(pond, k) && pond[k] > max) { max = pond[k]; key = k; }
    }
    return { key: key, val: max, label: lblPrueba(key) };
  }

  /* ============ API pública ============ */
  function isFav(cod) { return state.favs.has(cod); }
  function toggleFav(cod) {
    if (state.favs.has(cod)) state.favs.delete(cod);
    else state.favs.add(cod);
    saveFavs();
  }

  /* Sincronizar todas las estrellas del DOM con el estado actual.
     Llamada después de operaciones masivas (clearAll, importación, etc.) */
  function refreshAllStarsInDOM() {
    $$('.ep-paes-card-star').forEach(function (st) {
      var card = st.closest('.ep-paes-card');
      if (!card) return;
      var cod = card.getAttribute('data-codigo');
      var fav = isFav(cod);
      st.classList.toggle('is-fav', fav);
      st.innerHTML = fav ? '★' : '☆';
      st.setAttribute('aria-label', fav ? 'Quitar de favoritos' : 'Agregar a favoritos');
      st.setAttribute('title',      fav ? 'Quitar de favoritos' : 'Agregar a favoritos');
    });
    /* También el botón modal si está abierto */
    var modalBtn = $('#ep-paes-modal-fav-btn');
    if (modalBtn) {
      var cod = modalBtn.getAttribute('data-codigo');
      actualizarBotonModal(modalBtn, isFav(cod));
    }
  }

  function clearAll() {
    state.favs.clear();
    saveFavs();
    render();
    refreshAllStarsInDOM();
  }

  function estrellaTarjeta(carrera) {
    var fav = isFav(carrera.codigo_demre);
    var btn = el('button', {
      type: 'button',
      class: 'ep-paes-card-star' + (fav ? ' is-fav' : ''),
      'aria-label': fav ? 'Quitar de favoritos' : 'Agregar a favoritos',
      title: fav ? 'Quitar de favoritos' : 'Agregar a favoritos',
      html: fav ? '★' : '☆'
    });
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleFav(carrera.codigo_demre);
      var nowFav = isFav(carrera.codigo_demre);
      btn.innerHTML = nowFav ? '★' : '☆';
      btn.classList.toggle('is-fav', nowFav);
      btn.setAttribute('aria-label', nowFav ? 'Quitar de favoritos' : 'Agregar a favoritos');
      btn.setAttribute('title',      nowFav ? 'Quitar de favoritos' : 'Agregar a favoritos');
      btn.classList.add('is-anim');
      setTimeout(function(){ btn.classList.remove('is-anim'); }, 350);
      render();
      var modalBtn = $('#ep-paes-modal-fav-btn');
      if (modalBtn && modalBtn.getAttribute('data-codigo') === carrera.codigo_demre) {
        actualizarBotonModal(modalBtn, nowFav);
      }
    });
    return btn;
  }
  function botonModal(carrera) {
    var fav = isFav(carrera.codigo_demre);
    var btn = el('button', {
      type: 'button',
      id: 'ep-paes-modal-fav-btn',
      'data-codigo': carrera.codigo_demre,
      class: 'ep-paes-modal-fav-btn' + (fav ? ' is-fav' : '')
    });
    actualizarBotonModal(btn, fav);
    btn.addEventListener('click', function () {
      toggleFav(carrera.codigo_demre);
      var nowFav = isFav(carrera.codigo_demre);
      actualizarBotonModal(btn, nowFav);
      var card = document.querySelector('.ep-paes-card[data-codigo="' + carrera.codigo_demre + '"] .ep-paes-card-star');
      if (card) {
        card.innerHTML = nowFav ? '★' : '☆';
        card.classList.toggle('is-fav', nowFav);
        card.setAttribute('aria-label', nowFav ? 'Quitar de favoritos' : 'Agregar a favoritos');
      }
      render();
    });
    return btn;
  }
  function actualizarBotonModal(btn, fav) {
    btn.innerHTML = (fav ? '★ Quitar de favoritas' : '☆ Agregar a favoritas');
    btn.classList.toggle('is-fav', fav);
  }

  /* ============ Computar filas para vistas ============ */
  function computarFilas() {
    var favList = Array.from(state.favs).map(findByCode).filter(Boolean);
    var rows = favList.map(function (c) {
      var r = computar(c, state.puntajes);
      var meta = getMeta(c);
      var diff = (r.pond != null && meta != null) ? Math.round((meta - r.pond) * 10) / 10 : null;
      var clase = r.completo
        ? (meta == null
            ? { id: 'sin', label: 'Sin meta ponderada', msg: 'Esta carrera no tiene puntaje ponderado de referencia oficial.' }
            : clasificar(diff))
        : { id: 'datos', label: 'Completa tus puntajes', msg: 'Ingresa tus puntajes arriba para ver tu avance.' };
      return { c: c, r: r, meta: meta, diff: diff, clase: clase, top: pruebaTop(c.ponderaciones || {}) };
    });
    var orderMap = { sobre: 0, cerca: 1, camino: 2, reforz: 3, sin: 4, datos: 5 };
    rows.sort(function (a, b) {
      var oa = orderMap[a.clase.id], ob = orderMap[b.clase.id];
      if (oa !== ob) return oa - ob;
      if (a.diff != null && b.diff != null) return a.diff - b.diff;
      return a.c.carrera.localeCompare(b.c.carrera, 'es');
    });
    return rows;
  }

  /* ============ Render principal ============ */
  function render() {
    var host = $('#ep-paes-favs');
    if (!host) return;
    host.innerHTML = '';
    host.appendChild(renderPanel());
  }

  function renderPanel() {
    var nFav = state.favs.size;
    var section = el('section', { class: 'ep-paes-favs-section' });

    /* HEADER */
    var head = el('div', { class: 'ep-paes-favs-header' });
    head.appendChild(el('h2', { class: 'ep-paes-favs-title', html: '<span class="ep-paes-favs-title-star">⭐</span> Mis carreras favoritas <span class="ep-paes-favs-count">' + nFav + '</span>' }));
    var headActions = el('div', { class: 'ep-paes-favs-head-actions' });
    headActions.appendChild(el('button', {
      type: 'button', class: 'ep-paes-favs-toggle',
      text: state.expanded ? 'Ocultar ▴' : 'Mostrar ▾',
      onclick: function () { state.expanded = !state.expanded; render(); }
    }));
    if (nFav > 0) {
      headActions.appendChild(el('button', {
        type: 'button', class: 'ep-paes-favs-clear',
        text: '✕ Limpiar favoritos',
        onclick: function () {
          if (confirm('¿Eliminar todas las carreras favoritas? Tus puntajes globales se mantienen.')) {
            clearAll();
          }
        }
      }));
    }
    head.appendChild(headActions);
    section.appendChild(head);

    /* AVISO DISCRETO: persistencia automática en localStorage.
       NO es un popup; es un mini-badge en el header. Tres estados:
         1) file:// → advertencia ámbar: el navegador puede no persistir
         2) localStorage bloqueado (incógnito) → advertencia ámbar
         3) Todo OK → mini-badge cian normal */
    var saveNotice = el('div', { class: 'ep-paes-favs-save-notice' });
    var isFile = (location.protocol === 'file:');
    if (isFile) {
      saveNotice.className = 'ep-paes-favs-save-notice is-file';
      saveNotice.appendChild(el('span', { class: 'icon', text: '⚠️' }));
      saveNotice.appendChild(el('span', { class: 'txt', html: 'Estás abriendo la herramienta en <strong>modo archivo local (file://)</strong>. Para guardar favoritas y puntajes de forma confiable, abre el buscador con <strong>ABRIR_BUSCADOR_EUREKAPAES.bat</strong> o desde <strong>http://localhost</strong>.' }));
    } else if (storageAvailable()) {
      saveNotice.appendChild(el('span', { class: 'icon', text: '💾' }));
      saveNotice.appendChild(el('span', { class: 'txt', text: 'Tus favoritas y puntajes se guardan automáticamente en este navegador.' }));
    } else {
      saveNotice.className = 'ep-paes-favs-save-notice is-warn';
      saveNotice.appendChild(el('span', { class: 'icon', text: '⚠️' }));
      saveNotice.appendChild(el('span', { class: 'txt', text: 'Tu navegador bloqueó el guardado local (modo incógnito o permisos). Tus datos no se conservarán al cerrar la página.' }));
    }
    section.appendChild(saveNotice);

    /* TOOLBAR de acciones */
    if (state.expanded) {
      var toolbar = el('div', { class: 'ep-paes-favs-toolbar' });
      if (nFav >= 2 && window.EpComparador) {
        toolbar.appendChild(el('button', { type: 'button', class: 'ep-paes-favs-toolbtn', html: '⚖️ Comparar', onclick: function () { window.EpComparador.abrir(); } }));
      }
      if (nFav > 0 && window.EpExtras && window.EpExtras.ShareWA) {
        var waBtn = window.EpExtras.ShareWA.render();
        if (waBtn) toolbar.appendChild(waBtn);
      }
      if (window.EpExtras && window.EpExtras.Informe) {
        toolbar.appendChild(el('button', { type: 'button', class: 'ep-paes-favs-toolbtn', html: '📥 Descargar informe', onclick: function () { window.EpExtras.Informe.generar(); } }));
      }
      if (window.EpQuiz) {
        toolbar.appendChild(el('button', { type: 'button', class: 'ep-paes-favs-toolbtn is-quiz', html: '🤔 ¿No sé qué estudiar?', onclick: function () { window.EpQuiz.abrir(); } }));
      }
      if (window.EpExtras && window.EpExtras.Glosario) {
        toolbar.appendChild(el('button', { type: 'button', class: 'ep-paes-favs-toolbtn', html: '📖 Diccionario PAES', onclick: function () { window.EpExtras.Glosario.open(); } }));
      }
      section.appendChild(toolbar);
    }

    if (!state.expanded) return section;

    /* SIMULADOR GLOBAL */
    section.appendChild(renderSimuladorGlobal());

    if (nFav === 0) {
      section.appendChild(el('div', { class: 'ep-paes-favs-empty' }, [
        el('div', { class: 'ep-paes-favs-empty-emoji', text: '⭐' }),
        el('h3', { text: 'Aún no tienes carreras favoritas' }),
        el('p',  { text: 'Marca la estrella ☆ en cualquier carrera para guardarla aquí y compararla con tus puntajes.' })
      ]));
      return section;
    }

    var rows = computarFilas();

    /* DASHBOARD */
    section.appendChild(renderDashboard(rows));

    /* SELECTOR DE VISTAS */
    section.appendChild(renderTabs());

    /* CONTENIDO DE LA VISTA ACTIVA */
    var vistaBox = el('div', { class: 'ep-paes-vista-host' });
    if (state.vista === 'tabla')      vistaBox.appendChild(renderVistaTabla(rows));
    else                               vistaBox.appendChild(renderVistaTarjetas(rows));
    section.appendChild(vistaBox);

    /* RADAR, HISTOGRAMA, PLAN DE ATAQUE y ANÁLISIS POR PRUEBA eliminados
       por petición del usuario (jul 2026). Sus módulos siguen disponibles
       pero no se renderizan. */

    /* CTA INTELIGENTE según prueba más urgente */
    if (window.EpExtras && window.EpExtras.CTA) {
      var cta = window.EpExtras.CTA.render();
      if (cta) section.appendChild(cta);
    }

    /* RANKING, MAPA REGIÓN y HEATMAP "Mapa de oportunidades" se mantienen
       como funciones disponibles en sus módulos, pero NO se renderizan en el
       flujo principal (eliminados por petición del usuario). */

    return section;
  }

  /* ============ Selector de vistas ============ */
  function renderTabs() {
    var box = el('div', { class: 'ep-paes-vista-tabs', role: 'tablist' });
    VISTAS.forEach(function (v) {
      box.appendChild(el('button', {
        type: 'button',
        role: 'tab',
        'aria-selected': state.vista === v.id ? 'true' : 'false',
        class: 'ep-paes-vista-tab' + (state.vista === v.id ? ' is-active' : ''),
        html: '<span class="ic">' + v.icon + '</span><span class="lbl">' + escapeHtml(v.label) + '</span>',
        onclick: function () {
          if (state.vista === v.id) return;
          state.vista = v.id;
          saveVista();
          /* Re-render solo del host de vista */
          var section = $('#ep-paes-favs .ep-paes-favs-section');
          if (section) {
            var tabsOld = section.querySelector('.ep-paes-vista-tabs');
            if (tabsOld) tabsOld.replaceWith(renderTabs());
            var hostOld = section.querySelector('.ep-paes-vista-host');
            if (hostOld) {
              var rows = computarFilas();
              var nuevo = el('div', { class: 'ep-paes-vista-host' });
              if (state.vista === 'tabla')      nuevo.appendChild(renderVistaTabla(rows));
              else                               nuevo.appendChild(renderVistaTarjetas(rows));
              hostOld.replaceWith(nuevo);
            }
          }
        }
      }));
    });
    return box;
  }

  /* ============ Dashboard (sin "prueba clave más repetida") ============ */
  function renderDashboard(rows) {
    var nTotal  = rows.length;
    var nSobre  = rows.filter(function (r) { return r.clase.id === 'sobre'; }).length;
    var nCerca  = rows.filter(function (r) { return r.clase.id === 'cerca'; }).length;
    var nCamino = rows.filter(function (r) { return r.clase.id === 'camino'; }).length;
    var nReforz = rows.filter(function (r) { return r.clase.id === 'reforz'; }).length;
    var nDatos  = rows.filter(function (r) { return r.clase.id === 'datos'; }).length;

    /* Carrera más exigente: la que tiene meta más alta */
    var maxMeta = -1, exigente = null;
    rows.forEach(function (r) { if (r.meta != null && r.meta > maxMeta) { maxMeta = r.meta; exigente = r.c; } });

    /* Favorita más cercana: la con menor diff positivo o cualquier sobre la meta */
    var favCercana = null, minDiff = Infinity;
    rows.forEach(function (r) {
      if (r.diff == null) return;
      if (r.diff <= 0 && favCercana == null) { favCercana = r; minDiff = r.diff; }
      else if (r.diff > 0 && r.diff < minDiff) { favCercana = r; minDiff = r.diff; }
    });

    var dash = el('div', { class: 'ep-paes-favs-dash' });
    dash.appendChild(stat('⭐', nTotal, nTotal === 1 ? 'favorita' : 'favoritas'));
    /* Stats por estado (sobre/cerca/camino/reforzar) eliminadas del dashboard.
       Mantenemos solo "favorita más cercana/holgada" y "más exigente" abajo. */

    if (favCercana) {
      var lblF, valF;
      if (favCercana.diff <= 0) {
        lblF = '🚀 Favorita más holgada';
        valF = favCercana.c.carrera + ' — sobre la meta por ' + Math.abs(favCercana.diff) + ' pts';
      } else {
        lblF = '🎯 Favorita más cercana';
        valF = favCercana.c.carrera + ' — te faltan ' + favCercana.diff + ' pts';
      }
      dash.appendChild(el('div', { class: 'ep-paes-favs-stat is-wide' }, [
        el('div', { class: 'ic', text: favCercana.diff <= 0 ? '🚀' : '🎯' }),
        el('div', { class: 'info' }, [
          el('div', { class: 'lbl', text: favCercana.diff <= 0 ? 'Más holgada' : 'Más cercana' }),
          el('div', { class: 'val ellipsis', text: favCercana.c.carrera }),
          el('div', { class: 'sub ellipsis', text: favCercana.c.universidad + ' · ' + valF.split('—')[1].trim() })
        ])
      ]));
    }
    if (exigente) {
      dash.appendChild(el('div', { class: 'ep-paes-favs-stat is-wide' }, [
        el('div', { class: 'ic', text: '🔥' }),
        el('div', { class: 'info' }, [
          el('div', { class: 'lbl', text: 'Más exigente' }),
          el('div', { class: 'val ellipsis', text: exigente.carrera }),
          el('div', { class: 'sub ellipsis', text: exigente.universidad + ' · meta ' + fmt(maxMeta) })
        ])
      ]));
    }
    return dash;
  }
  function stat(icon, num, lbl) {
    return el('div', { class: 'ep-paes-favs-stat' }, [
      el('div', { class: 'ic', text: icon }),
      el('div', { class: 'info' }, [
        el('div', { class: 'val num', text: String(num) }),
        el('div', { class: 'sub', text: lbl })
      ])
    ]);
  }

  /* ============ Simulador global (grid 4+3) ============ */
  function renderSimuladorGlobal() {
    var box = el('div', { class: 'ep-paes-simglob' });
    box.appendChild(el('div', { class: 'ep-paes-simglob-head' }, [
      el('h3', { class: 'ep-paes-simglob-title', html: '🧠 Mis puntajes' }),
      el('p',  { class: 'ep-paes-simglob-sub', text: 'Ingresa tus puntajes estimados una sola vez. Se guardan en este navegador y se aplican automáticamente a todas tus favoritas. Rango: 0 a 1000.' })
    ]));
    var grid = el('div', { class: 'ep-paes-simglob-grid is-4-3' });
    PRUEBAS.forEach(function (p, idx) {
      var box1 = el('label', { class: 'ep-paes-simglob-input' + (state.puntajes[p.key] != null ? ' is-filled' : '') });
      box1.appendChild(el('span', { class: 'lbl', html: '<span class="ic">' + p.icon + '</span>' + escapeHtml(p.label) }));
      var inp = el('input', {
        type: 'number', min: '0', max: '1000', step: '0.1',
        inputmode: 'decimal', id: 'sg-' + p.key, placeholder: '0 a 1000',
        value: state.puntajes[p.key] != null ? state.puntajes[p.key] : '',
        'aria-label': p.label
      });
      box1.appendChild(inp);
      grid.appendChild(box1);
    });
    box.appendChild(grid);
    var foot = el('div', { class: 'ep-paes-simglob-foot' });
    foot.appendChild(el('button', {
      type: 'button', class: 'ep-paes-simglob-clear',
      text: '↺ Limpiar mis puntajes',
      onclick: function () {
        if (confirm('¿Borrar tus puntajes globales? Tus favoritas se mantienen.')) {
          state.puntajes = {}; savePuntajes(); render();
        }
      }
    }));
    box.appendChild(foot);

    grid.addEventListener('input', function (e) {
      var tg = e.target;
      if (!tg || !tg.id || tg.id.indexOf('sg-') !== 0) return;
      var key = tg.id.substring(3);
      var raw = (tg.value || '').replace(',', '.');
      var v = parseFloat(raw);
      if (isNaN(v)) {
        delete state.puntajes[key];
      } else {
        var c = clamp(v, 0, 1000);
        if (c !== v) tg.value = c;
        state.puntajes[key] = c;
      }
      savePuntajes();
      tg.parentElement.classList.toggle('is-filled', !isNaN(v));
      /* Refrescar dashboard + vista activa */
      rerenderVistaYDashboard();
    });
    return box;
  }

  /* Función central: re-renderiza TODAS las secciones que dependen de los puntajes
     del estudiante o de las favoritas. NO toca el simulador global para no perder
     el foco del input. También sincroniza con el modal si está abierto. */
  function refreshAllStudentDependentSections() {
    var section = $('#ep-paes-favs .ep-paes-favs-section');
    if (!section) return;
    if (state.favs.size === 0) return;
    var rows = computarFilas();

    /* Dashboard */
    var oldDash = section.querySelector('.ep-paes-favs-dash');
    if (oldDash) oldDash.replaceWith(renderDashboard(rows));

    /* Vista activa */
    var oldHost = section.querySelector('.ep-paes-vista-host');
    if (oldHost) {
      var nuevo = el('div', { class: 'ep-paes-vista-host' });
      if (state.vista === 'tabla') nuevo.appendChild(renderVistaTabla(rows));
      else nuevo.appendChild(renderVistaTarjetas(rows));
      oldHost.replaceWith(nuevo);
    }

    /* Radar, histograma, plan de ataque y análisis por prueba: eliminados
       por petición del usuario (jul 2026). Si quedara un nodo antiguo en el
       DOM, se limpia. */
    var oldViz = section.querySelector('.ep-paes-viz-row');
    if (oldViz) oldViz.remove();
    var oldPlan = section.querySelector('.ep-paes-plan');
    if (oldPlan) oldPlan.remove();
    var oldAna = section.querySelector('.ep-paes-analisis');
    if (oldAna) oldAna.remove();

    /* CTA inteligente */
    var oldCta = section.querySelector('.ep-paes-cta-inteligente');
    if (oldCta && window.EpExtras && window.EpExtras.CTA) {
      var newCta = window.EpExtras.CTA.render();
      if (newCta) oldCta.replaceWith(newCta);
    }

    /* Heatmap no depende de puntajes; no se refresca */

    /* Sincronizar modal si está abierto */
    if (state.modalActual && window.EpPaesAbrirModal) {
      /* Re-renderizar el contenido del modal manteniendo la misma carrera */
      var c = state.modalActual;
      window.EpPaesAbrirModal(c);
    }

    /* Si el comparador está abierto, refrescarlo */
    var compOverlay = document.getElementById('ep-paes-comp-overlay');
    if (compOverlay && window.EpComparador && window.EpComparador.refresh) {
      try { window.EpComparador.refresh(); } catch (e) {}
    }
  }
  /* Alias para retro-compatibilidad */
  function rerenderVistaYDashboard() { refreshAllStudentDependentSections(); }

  /* ============ VISTA 1: TARJETAS (la actual mejorada) ============ */
  function renderVistaTarjetas(rows) {
    var list = el('div', { class: 'ep-paes-favs-list' });
    rows.forEach(function (row) { list.appendChild(renderFavCard(row)); });
    return list;
  }

  function renderFavCard(row) {
    var c = row.c;
    var card = el('article', { class: 'ep-paes-fav-card is-estado-' + row.clase.id });
    var head = el('div', { class: 'ep-paes-fav-card-head' });
    head.appendChild(el('div', { class: 'ep-paes-fav-card-info' }, [
      el('h4', { class: 'ep-paes-fav-card-titulo', text: c.carrera }),
      el('div',{ class: 'ep-paes-fav-card-uni', text: c.universidad }),
      el('div',{ class: 'ep-paes-fav-card-meta', text: '#' + c.codigo_demre + (c.region ? ' · ' + c.region : '') + (c.sede ? ' · Sede ' + c.sede : '') })
    ]));
    head.appendChild(el('button', {
      type: 'button', class: 'ep-paes-fav-card-remove', 'aria-label': 'Quitar de favoritos', html: '✕',
      onclick: function () {
        toggleFav(c.codigo_demre);
        render();
        var st = document.querySelector('.ep-paes-card[data-codigo="' + c.codigo_demre + '"] .ep-paes-card-star');
        if (st) { st.innerHTML = '☆'; st.classList.remove('is-fav'); st.setAttribute('aria-label','Agregar a favoritos'); }
      }
    }));
    card.appendChild(head);

    var estadoBox = el('div', { class: 'ep-paes-fav-card-estado ep-paes-estado-' + row.clase.id });
    estadoBox.appendChild(el('span', { class: 'ep-paes-fav-card-estado-pill', text: row.clase.label }));
    estadoBox.appendChild(el('span', { class: 'ep-paes-fav-card-estado-msg', text: row.clase.msg }));
    card.appendChild(estadoBox);

    var grid = el('div', { class: 'ep-paes-fav-card-grid' });
    grid.appendChild(el('div', { class: 'ep-paes-fav-card-cell' }, [
      el('div', { class: 'cell-lbl', text: 'Tu ponderado' }),
      el('div', { class: 'cell-val', text: row.r.pond != null ? fmt(row.r.pond) : '—' })
    ]));
    grid.appendChild(el('div', { class: 'ep-paes-fav-card-cell' }, [
      el('div', { class: 'cell-lbl', text: row.meta != null ? 'Meta ponderada' : 'Referencia DEMRE' }),
      el('div', { class: 'cell-val', text: row.meta != null ? fmt(row.meta) : (c.puntaje_corte_clec_m1 != null ? fmt(c.puntaje_corte_clec_m1) + ' (CLEC+M1)' : '—') })
    ]));
    if (row.diff != null) {
      grid.appendChild(el('div', { class: 'ep-paes-fav-card-cell' }, [
        el('div', { class: 'cell-lbl', text: row.diff <= 0 ? 'Tu margen' : 'Te faltan' }),
        el('div', { class: 'cell-val', text: row.diff <= 0 ? ('+' + Math.abs(row.diff)) : (row.diff + ' pts') })
      ]));
    }
    card.appendChild(grid);

    if (row.r.pond != null && row.meta != null) {
      var pct = Math.max(0, Math.min(110, (row.r.pond / row.meta) * 100));
      card.appendChild(el('div', { class: 'ep-paes-fav-bar' }, [
        el('i', { style: 'width:' + pct.toFixed(0) + '%' }),
        el('span', { class: 'mark' })
      ]));
    }

    if (c.electiva_ciencias_historia) {
      var txt;
      if (row.r.electivaUsada) {
        txt = '🔀 Electiva usada: <strong>' + (row.r.electivaUsada === 'ciencias' ? 'Ciencias' : 'Historia') + '</strong>';
        if (row.r.electivaDescartada) txt += ' (descartada: ' + (row.r.electivaDescartada === 'ciencias' ? 'Ciencias' : 'Historia') + ')';
      } else {
        txt = '🔀 Falta ingresar electiva (Ciencias o Historia).';
      }
      card.appendChild(el('div', { class: 'ep-paes-fav-card-note', html: txt }));
    }
    if (row.top.key) {
      card.appendChild(el('div', { class: 'ep-paes-fav-card-note', html:
        '🔑 Prueba clave: <strong>' + escapeHtml(row.top.label) + ' (' + row.top.val + '%)</strong>'
      }));
    }

    var actions = el('div', { class: 'ep-paes-fav-card-actions' });
    actions.appendChild(el('button', {
      type: 'button', class: 'ep-paes-fav-card-btn', text: 'Ver detalle  →',
      onclick: function () { if (window.EpPaesAbrirModal) window.EpPaesAbrirModal(c); }
    }));
    if (row.top.key && state.puntajes[row.top.key] != null) {
      actions.appendChild(el('button', {
        type: 'button', class: 'ep-paes-fav-card-btn is-secondary',
        text: '+50 a ' + cortoPrueba(row.top.key),
        title: 'Simular subir tu prueba clave en 50 pts',
        onclick: function () {
          var current = state.puntajes[row.top.key];
          var boost = Math.min(1000, current + 50);
          var delta = (boost - current) * (row.top.val / 100);
          var newPond = row.r.pond != null ? Math.round((row.r.pond + delta) * 10) / 10 : null;
          var msg = 'Si subes ' + row.top.label + ' de ' + current + ' a ' + boost +
                    ' (+50 pts), tu ponderado en "' + c.carrera + '" subiría' +
                    (newPond != null ? ' a ' + newPond + ' (+' + (Math.round(delta * 10) / 10) + ' pts)' : ' significativamente');
          alert(msg);
        }
      }));
    }
    card.appendChild(actions);
    return card;
  }

  /* ============ VISTA 2: TABLA ============ */
  function renderVistaTabla(rows) {
    var wrap = el('div', { class: 'ep-paes-tabla-wrap' });
    var table = el('table', { class: 'ep-paes-tabla' });
    var thead = el('thead');
    thead.appendChild(el('tr', null, [
      el('th', { text: 'Carrera' }),
      el('th', { text: 'Universidad' }),
      el('th', { text: 'Código' }),
      el('th', { text: 'Región / Sede' }),
      el('th', { text: 'Meta' }),
      el('th', { text: 'Tu ponderado' }),
      el('th', { text: 'Diferencia' }),
      el('th', { text: 'Estado' }),
      el('th', { text: 'Prueba clave' }),
      el('th', { text: 'Ponderaciones' }),
      el('th', { text: '' })
    ]));
    table.appendChild(thead);

    /* Agrupar por área */
    var byArea = {};
    rows.forEach(function (r) {
      var a = r.c.area || 'Sin área';
      if (!byArea[a]) byArea[a] = [];
      byArea[a].push(r);
    });
    var areasOrdenadas = Object.keys(byArea).sort(function (a, b) { return a.localeCompare(b, 'es'); });
    var tbody = el('tbody');
    areasOrdenadas.forEach(function (area) {
      tbody.appendChild(el('tr', { class: 'ep-paes-tabla-grp' }, [
        el('td', { colspan: '11', html: '<span class="ep-paes-tabla-grp-icon">📚</span> ' + escapeHtml(area) + ' <span class="ep-paes-tabla-grp-count">' + byArea[area].length + '</span>' })
      ]));
      byArea[area].forEach(function (row) { tbody.appendChild(renderFilaTabla(row)); });
    });
    table.appendChild(tbody);
    wrap.appendChild(table);
    return wrap;
  }

  function renderFilaTabla(row) {
    var c = row.c;
    var tr = el('tr', { class: 'ep-paes-tabla-fila is-estado-' + row.clase.id });
    tr.appendChild(el('td', { class: 'col-carrera' }, [
      el('div', { class: 'cel-titulo', text: c.carrera }),
      (c.sede ? el('div', { class: 'cel-sub', text: 'Sede ' + c.sede }) : null)
    ]));
    tr.appendChild(el('td', { class: 'col-uni', text: c.universidad }));
    tr.appendChild(el('td', { class: 'col-cod', text: c.codigo_demre || '—' }));
    tr.appendChild(el('td', { class: 'col-reg', text: c.region || '—' }));
    tr.appendChild(el('td', { class: 'col-meta col-num', text: row.meta != null ? fmt(row.meta) : (c.puntaje_corte_clec_m1 != null ? fmt(c.puntaje_corte_clec_m1) + '*' : '—') }));
    tr.appendChild(el('td', { class: 'col-pond col-num', text: row.r.pond != null ? fmt(row.r.pond) : '—' }));
    var diffTxt = '—';
    if (row.diff != null) diffTxt = row.diff <= 0 ? '+' + Math.abs(row.diff) : '-' + row.diff;
    if (!row.r.completo) diffTxt = 'faltan datos';
    tr.appendChild(el('td', { class: 'col-diff col-num is-' + row.clase.id, text: diffTxt }));
    tr.appendChild(el('td', { class: 'col-estado' }, [
      el('span', { class: 'ep-paes-tabla-pill ep-paes-estado-' + row.clase.id, text: row.clase.label })
    ]));
    var topTxt = row.top.key ? row.top.label + ' (' + row.top.val + '%)' : '—';
    if (c.electiva_ciencias_historia && row.r.electivaUsada) {
      topTxt += ' · 🔀 ' + (row.r.electivaUsada === 'ciencias' ? 'Ciencias' : 'Historia');
    }
    tr.appendChild(el('td', { class: 'col-clave', text: topTxt }));
    /* Ponderaciones inline (Opción A) */
    var pondTxt = '';
    var pond = c.ponderaciones || {};
    var pondArr = [];
    PRUEBAS.forEach(function (p) {
      if (pond[p.key] && pond[p.key] > 0) pondArr.push(p.corto + ' ' + pond[p.key] + '%');
    });
    pondTxt = pondArr.join(' · ');
    tr.appendChild(el('td', { class: 'col-pondlist', text: pondTxt }));
    tr.appendChild(el('td', { class: 'col-action' }, [
      el('button', { type: 'button', class: 'ep-paes-tabla-btn', text: 'Ver →',
        onclick: function () { if (window.EpPaesAbrirModal) window.EpPaesAbrirModal(c); }
      })
    ]));
    return tr;
  }

  /* Vista "Prioridades" (kanban) eliminada por petición del usuario (jul 2026). */

  /* ============ Expose ============ */
  window.EpFavs = {
    isFav: isFav,
    estrellaTarjeta: estrellaTarjeta,
    botonModal: botonModal,
    render: render,
    refreshAllStarsInDOM: refreshAllStarsInDOM,
    /* Función central que cualquier módulo puede llamar para refrescar
       todas las secciones que dependen de puntajes/favoritas */
    refreshDerived: refreshAllStudentDependentSections
  };

  function init() {
    if (!document.getElementById('ep-paes-favs')) return;
    if (!getDataArr().length) { setTimeout(init, 200); return; }
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
